import { render, staticRenderFns } from "./modebtns.vue?vue&type=template&id=5037387c&scoped=true&"
import script from "./modebtns.vue?vue&type=script&lang=js&"
export * from "./modebtns.vue?vue&type=script&lang=js&"
import style0 from "./modebtns.vue?vue&type=style&index=0&id=5037387c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037387c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
